"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert = exports.setUserCurrency = exports.getUserCurrency = exports.getShopCurrency = exports.CURRENCY_COOKIE_NAME = void 0;
var Cookies = require("js-cookie");
var jquery_1 = require("../jquery");
exports.CURRENCY_COOKIE_NAME = 'currency';
var getShopCurrency = function () {
    var c = window['Currency'];
    if (!c || !c.currency)
        throw new Error('You have not defined your shops currency onto window.Currency.currency!');
    return c.currency;
};
exports.getShopCurrency = getShopCurrency;
var getUserCurrency = function () {
    if (Cookies.get(exports.CURRENCY_COOKIE_NAME))
        return Cookies.get(exports.CURRENCY_COOKIE_NAME);
    return (0, exports.getShopCurrency)();
};
exports.getUserCurrency = getUserCurrency;
var setUserCurrency = function (currency) {
    var current = (0, exports.getUserCurrency)();
    if (current === currency)
        return;
    Cookies.set(exports.CURRENCY_COOKIE_NAME, currency);
    (0, jquery_1.jq)(document).trigger('onCurrencyChange', currency);
};
exports.setUserCurrency = setUserCurrency;
var convert = function (money, from, to) {
    var c = window['Currency'];
    from = from || (0, exports.getShopCurrency)();
    to = to || (0, exports.getShopCurrency)();
    if (from === to)
        return money;
    if (!c || !c.convert)
        throw new Error('You havent imported the Shopify currencies script in your header scripts!');
    return c.convert(money, from, to);
};
exports.convert = convert;
//# sourceMappingURL=convert.js.map